// Translation keys (published under I18N_STORE_PATH in the i18n store).
export const I18N_KEYS = {
  LAUNCH_ERROR: 'ticketErrorLaunch',
  LOADING_FORM: 'ticketLoadingForm',
  LOADING_VERIFYING_SESSION: 'ticketLoadingVerifyingSession',
  LOADING_ARIA_LABEL: 'ticketLoadingAriaLabel',
  SUBMIT_LABEL: 'ticketFormSubmit',
  SUBMITTING_LABEL: 'ticketFormSubmitting',
  SUBMIT_SUCCESS_TITLE: 'ticketSubmitSuccessTitle',
  SUBMIT_SUCCESS_MESSAGE: 'ticketSubmitSuccessMessage',
  SUBMIT_FAILURE_TITLE: 'ticketSubmitFailureTitle',
  SUBMIT_FAILURE_MESSAGE: 'ticketSubmitFailureMessage',
  FILE_MAX_FILES_ONE: 'ticketFileMaxFilesOne',
  FILE_MAX_FILES_OTHER: 'ticketFileMaxFilesOther',
  VALIDATION_REQUIRED: 'ticketValidationRequired',
  VALIDATION_MAX_LENGTH: 'ticketValidationMaxLength',
  VALIDATION_INVALID_EMAIL: 'ticketValidationInvalidEmail',
  VALIDATION_INVALID_PHONE: 'ticketValidationInvalidPhone',
  PAGE_TITLE: 'ticketPageTitle'
};

export const PAGE_TITLE = 'Create Ticket';

// English defaults, used as `defaultValue` when a key is not (yet) present in
// the i18n store.
export const LAUNCH_ERROR_MESSAGE = 'Unable to launch ticket creation. Please try again.';
export const LOADING_FORM_MESSAGE = 'Loading ticket form…';
export const LOADING_VERIFYING_SESSION_MESSAGE = 'Verifying session…';
export const LOADING_ARIA_LABEL = 'Loading';

export const SUBMIT_LABEL = 'Submit';
export const SUBMITTING_LABEL = 'Submitting…';

export const SUBMIT_SUCCESS_TITLE = 'Success';
export const SUBMIT_FAILURE_TITLE = 'Error';
export const SUBMIT_FAILURE_MESSAGE =
  'There was an error while submitting your ticket. Please try submitting another ticket again.';
export const SUBMIT_SUCCESS_MESSAGE_TEMPLATE =
  'Ticket {{ticketId}} has been successfully created. You can close the window now.';

export const normalizeTicketId = ticketId => String(ticketId ?? '').replace(/^#+/, '');

export const formatSubmitSuccessMessage = ticketId =>
  SUBMIT_SUCCESS_MESSAGE_TEMPLATE.replace('{{ticketId}}', normalizeTicketId(ticketId));
